/* ══════════════════════════════════════════════════════════════════
   **Ein Einmalbetrag ist keine Tagesmiete** (Prüfrunde Runde 11, „Neu
   gesehen", 05.10.2026).

   Die Mulde (Preisart „Einmalbetrag je Miete", 90,00 — ein **Beispiel**)
   stand an der Trefferzeile als „1 × 90,00 je Tag", auf AB0135/AB0137 und
   RE1036 als „1 Tag × 90,00". Gerechnet war sie richtig — einmal je Miete
   (Rechenreferenz 2.5, P4) —, nur die Einheit kam aus der Tarifzeile
   (`rental_rate.unit = 'tag'`). Seitdem nennt `packages/fach` für die
   Preisart `fixpreis` die Einheit `einheit.pauschale`, und Lauf und AB
   folgen ihr.

   In der Oberfläche liest sich „90,00 je Pauschale × 1" aber nicht besser.
   Für eine Pauschale steht deshalb dieselbe Form wie auf Vorschlag und
   Rechnung: **„1 Pauschale × 90,00"**. Für jede andere Einheit bleibt es,
   wie es war („60,00 je Tag × 5").
   ══════════════════════════════════════════════════════════════════ */

/** Ist das die Einheit eines Einmalbetrags? Beide Schreibweisen kommen vor (`mitte/einheiten.ts`). */
export function istPauschale(einheitKey: string | null | undefined): boolean {
  return einheitKey === "einheit.pauschale" || einheitKey === "einheit.pauschal";
}

/** Welcher Satz die Rechnung „Satz × Menge" zeigt — der Schlüssel, je nach Einheit. */
export function satzMalSchluessel(einheitKey: string | null | undefined, sonst: string, pauschal: string): string {
  return istPauschale(einheitKey) ? pauschal : sonst;
}
